import React from 'react';
import '../App.css';
import JobDescription from './JobDescription';
import ConnectionsList from './ConnectionsList';

const JobDetails = ({ job, showAllConnections, onToggleConnections }) => {
  if (!job) return null;

  const getSourceFromUrl = (url) => {
    if (!url) return 'View Job';
    const urlObj = new URL(url);
    const hostname = urlObj.hostname.toLowerCase();
    
    if (hostname.includes('linkedin')) return 'View on LinkedIn';
    if (hostname.includes('indeed')) return 'View on Indeed';
    if (hostname.includes('glassdoor')) return 'View on Glassdoor';
    if (hostname.includes('bayt')) return 'View on Bayt';
    if (hostname.includes('google')) return 'View on Google';
    
    return 'View Job';
  };

  return (
    <div className="job-details">
      <h2>{job.title}</h2>
      <h3>{job.company}</h3>
      <p>{job.location}</p>
      
      <div className="job-description">
        <JobDescription description={job.description} />
      </div>

      <ConnectionsList 
        connections={job.connections}
        company={job.company}
        showAll={showAllConnections}
        onToggleShow={onToggleConnections}
        jobTitle={job.title}
      />
      
      {job.job_url && (
        <button 
          onClick={() => window.open(job.job_url, '_blank')}
          style={{
            backgroundColor: 'black',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '8px 16px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            marginTop: '16px'
          }}
        >
          {getSourceFromUrl(job.job_url)}
        </button>
      )}
    </div>
  );
};

export default JobDetails; 